export interface IUploadInfoFields {
  key: string;
  'Content-Type': string;
  bucket: string;
  'X-Amz-Algorithm': string;
  'X-Amz-Credential': string;
  'X-Amz-Date': string;
  'X-Amz-Security-Token': string;
  Policy: string;
  'X-Amz-Signature': string;
}

export interface IUploadInfo {
  url: string;
  fields: IUploadInfoFields;
}
